import { gql } from '@apollo/client';
import { IOrder } from '@global/types/types';

export interface UPDATE_CART_TYPE {
  updateViaxCustomerOrder: IOrder;
}

export const UPDATE_CART = gql`
  mutation updateCartWithNewCustomer(
    $uid: UUID!
    $hiConsistsOf: [CustomerOrderItemInput!]
    $corPromoCodes: [PromotionInput!]
  ) {
    updateViaxCustomerOrder(
      input: {
        uid: $uid
        hiConsistsOf: $hiConsistsOf
        corPromoCodes: $corPromoCodes
      }
    ) {
      corPromoCodes {
        ... on ViaxTrialPromotion {
          id
          uid
          prmId
          typeName
          prmName
          trpDuration {
            amount
            units
          }
        }
      }
      uid
      id
      biCreatedAt
      hiConsistsOf {
        biiId
        biiSequentialId
        biiSalable: wtTransactable {
          ... on Product {
            maId
            maName
          }
          __typename
        }
        pricPrice {
          edges {
            mapsOn {
              code
            }
            node {
              amount
              units {
                code
              }
            }
          }
        }
      }
      pricPrice {
        edges {
          mapsOn {
            code
          }
          node {
            amount
            units {
              code
            }
          }
        }
      }
    }
  }
`;
